import styled from "styled-components";

export const Main = styled.div`
   display: flex;
   align-items: stretch;
   gap: 8px;
   margin-bottom: 8px;

   &.withLine {
      position: relative;
      padding-bottom: 17.5px;
      margin-bottom: 11px;

      &::after {
         content: '';
         position: absolute;
         left: 0;
         bottom: 0;
         width: 100%;
         height: 0.5px;
         background-color: rgb(220, 220, 220);
      }
   }
   .select {
      width: 100% !important;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      > div { 
         width: 100% !important;
         min-width: 100% !important; 
      }
   }
   button {
      gap: 6px;
      color: #fff !important;
      border: 1px solid rgba(37, 99, 235, .35) !important;
      border-radius: 8px !important;
      box-shadow: 0 2px 5px rgba(37, 99, 235, .18) !important;
      font-weight: 600;
      white-space: nowrap;

      &:hover:not(:disabled) {
         background-color: #2563eb !important;
         border-color: #2563eb !important;
         box-shadow: 0 4px 10px rgba(37, 99, 235, .28) !important;
         transform: translateY(-1px);
      }

      &:focus-visible {
         outline: 3px solid rgba(59, 130, 246, .25);
         outline-offset: 2px;
      }

      &:first-of-type {
         min-width: 44px;
         width: 44px;
         padding: 0 !important;
         margin-left: 0;
      }
      &:last-of-type {
         min-width: 116px;
         width: auto;
         padding: 0 16px !important;
         margin-left: 0;
      }

      &:disabled {
         cursor: not-allowed;
         opacity: .65;
      }

      svg {
         flex-shrink: 0;
         color: #fff !important;
         stroke: currentColor;
      }

      .spinning {
         animation: connection-refresh-spin .8s linear infinite;
      }
   }

   @keyframes connection-refresh-spin {
      to { transform: rotate(360deg); }
   }
`;
